
<mat-card appearance="outlined">
    <app-transformer-top-header [isReadOnly]="isReadOnly" [viewModel]="viewModel" [transformslists]="transformslists" [iconpath]="iconpath" [nodeColor]="nodeColor" [transformNameType]="transformNameType" [aboutlink]="aboutlink"
    [refineryConfigGuid]="refineryConfigGuid" [refineryName]="refineryName" [nodeName]="nodeName" [nodeIndex]="nodeIndex" [configGuid]="configGuid" [cacheStatus]="cacheStatus" (onRefreshCacheStatus)="getCacheStatus()" (onPurgeCache)="purgeCache()"
    (onTransformTextChanged)="onTransformTextChanged()"
    (onViewTransformConfigJson)="viewTransformConfigJson()"
    (onRunTransform)="onRunTransformValidate()"
    (onSaveConfig)="saveConfig()" (onShowTransformDetail)="showTransformDetail($event)" (onImportTransformer)="loadImportTransformer($event)" [hasResetSupport]="true" (onResetTransform)="resetTransformer()"
    [compiledConfigHash]="compiledConfigHash" [compiledAt]="compiledAt" [compiledConfig]="compiledConfig" [lastAuditHash]="lastAuditHash" [lastAuditResult]="lastAuditResult" (onAuditCompleted)="onAuditCompleted($event)" [hasRules]="viewModel?.rules?.length > 0"
    [transformType]="viewModel?.transform?.transformType" [currentConfigJson]="viewModel?.toTransformConfig()"
    [inputCacheKey]="copilotInputCacheKey"
    [sourceColumn]="columnCleanerDefaultSourceField"
    [availableSourceFields]="columnCleanerAvailableSourceFields"
    [currentSampleStart]="viewModel?.parameters?.sampleStart ?? 0"
    [currentSampleEnd]="viewModel?.parameters?.sampleEnd ?? 0"
    (onApplySmartSample)="applySmartSample($event)"></app-transformer-top-header>
    <mat-card-content class="content-with-fixed-header">
        <!-- Description -->
        <mat-expansion-panel class="mat-elevation-z0" style="margin-top:5px;">
            <mat-expansion-panel-header>Description</mat-expansion-panel-header>
            <app-transformer-description [analystDescription]="viewModel.transform.analystDescription"
                (analystDescriptionChange)="viewModel.transform.analystDescription = $event"></app-transformer-description>
        </mat-expansion-panel>
        <!-- Parameters -->
        <mat-expansion-panel class="mat-elevation-z0" expanded style="margin-top:5px;">
            <mat-expansion-panel-header>Parameters<span *ngIf="isValidateParameters" class="mat-error" style="margin-left: 5px;">Missing Required Fields</span></mat-expansion-panel-header>
            <div style="display: flex;margin-top:-10px;margin-left: -3px;">
                <div>
                    <app-transformer-parameters [viewModel]="viewModel.parameters" [sourceColumns]="viewModel.sourceColumnsDT" 
                    (SetDefaultRule)="onSetDefaultRule($event)" 
                    (ToggleRulesColumnDisplay)="onToggleRulesColumnDisplay()" 
                    (formStatus)="onParameterFormStatusChange($event)"></app-transformer-parameters>
                </div>
                <div style="margin-left: 5x;">
                    <div style="margin-top: 45px;">
                    </div>
                    <div>
                        <mat-form-field [formGroup]="form" style="width: 70px;margin-left: -170px; margin-top: 0px;">
                            <mat-label>{{threads.label}}</mat-label>
                            <input matInput formControlName="threads" type="number" placeholder="Threads" [(ngModel)]="viewModel.threads" [required]="threads.isrequired" [min]="threads.min" [max]="threads.max" appIntegerPositiveOnly>
                        </mat-form-field>
                    </div>
                </div>
                <div style="margin-left: 5x;">
                    <div style="margin-top: 22px;">
                        <mat-slide-toggle labelPosition="before" color="primary" (change)="onToggleResetRows($event)" [checked]="viewModel.resetRows" ><span [innerHTML]="resetRows.label"></span></mat-slide-toggle>
                    </div>
                    <div>
                        <mat-form-field [formGroup]="form" style="width: 150px;">
                            <mat-label>{{findWildCard.label}}</mat-label>
                            <input matInput formControlName="findWildCard" type="text" placeholder="Find Wildcard" [(ngModel)]="viewModel.findWildCard" [required]="findWildCard.isrequired">
                        </mat-form-field>
                    </div>
                </div>
            </div>
        </mat-expansion-panel>
        <!-- Advanced Settings -->
        
        <!-- Rules -->
        <mat-expansion-panel class="mat-elevation-z0" expanded style="padding-top: 10px;">
            <mat-expansion-panel-header>
                <div style="display: flex; align-items: center; justify-content: center;">
                    <span style="margin-right: 10px">Rules</span>
                    
                    <button class="add-rule-btn" 
                        color="primary" mat-raised-button (click)="$event.stopPropagation(); addNewRule()"
                        title="Add new rule" style="height: 24px;border-radius: 2px;">
                        <mat-icon style="color: #fff;">add_circle</mat-icon>
                        <span style="color: black;">ADD SUBTRANSFORM</span>
                    </button>

                    <mat-form-field [formGroup]="form" style="margin-left: 20px;margin-bottom: 22px;" (click)="$event.stopPropagation();" class="matselectlabel">
                        <mat-label style="display: none;">Subtransformer Function</mat-label>
                        <mat-select [(value)]="viewModel.subTransformType">
                            <!-- <mat-option></mat-option> -->
                            <mat-option *ngFor="let ruleType of RuleTypes" [value]="ruleType">
                                {{RuleTypeUtil.toString(ruleType)}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <button (click)="$event.stopPropagation(); toggleRulesHeight();"
                        style="margin-left: 10px; line-height: 24px;height: 24px;border-radius: 2px;" color="primary"
                        mat-raised-button title="Show All" class="rule-toggle-btn" >
                        <mat-icon style="font-size: 20px;margin-right:0px">{{isRulesMaximized ? 'unfold_less' : 'unfold_more'}}
                        </mat-icon>
                    </button>
                </div>

            </mat-expansion-panel-header>

            <!--  [style.max-height.px]="isRulesMaximized ? '100000' : '386'" -->
            <div
                style="margin-top: 5px; margin-left: -6px; margin-right: -6px; padding-left: 6px; padding-right: 6px;" class="show-scrollbar"
                appMatTableAdjustRowHeight [RowCount]="isRulesMaximized ? maxrowcount : minrowcount" [MaxRowCount]="maxrowcount" [IsScrollBottom]="isScrollBottom">
                
                <h1 class="center" style=" color: lightgray" *ngIf="isRuleSetEmpty">No Subtransfromers</h1>

                <table *ngIf="!isRuleSetEmpty" (cdkDropListDropped)="dropTable($event)" mat-table
                    [dataSource]="dataSource" #table class="drag-list mat-elevation-z8" cdkDropList
                    [cdkDropListData]="dataSource">

                    <ng-container matColumnDef="ruleTypeIndex">
                        <th mat-header-cell *matHeaderCellDef class="no-padding-cell" style="width: 80px;"></th>
                        <!-- <td mat-cell style="width: 80px;" *matCellDef="let rule; let i = index" [attr.rowspan]="getRowSpan('ruleTypeIndex', i)" [style.display]="getRowSpan('ruleTypeIndex', i) ? '' : 'none'"> -->
                            <td mat-cell style="width: 80px;" *matCellDef="let rule; let i = index">
                            <ng-container *ngIf="rule.isGroup; else subheader">
                                <div style="display: flex; flex-direction: row; justify-content: flex-start; align-items: center">
                                   <!-- <mat-icon color="primary" matTooltip="Re-order Rule"  style="cursor: grab" cdkDrag [cdkDragData]="{ type: 'rule1', data: rule }"
                                        cdkDragRootElement=".drag-component" cdkDragHandle>reorder</mat-icon>
                                    <mat-icon style="margin-left: 2px; cursor: pointer" (click)="onDeleteRuleTypeIndex(rule)" matTooltip="Delete Rule" class="red-icon">delete_forever</mat-icon>
                                -->
                                <mat-icon
                                color="primary"
                                matTooltip="Re-order Rule"
                                matTooltipPosition="above"
                                #reorderTooltip="matTooltip"
                                (mouseenter)="reorderTooltip.show()"
                                (mouseleave)="reorderTooltip.hide()"
                                style="cursor: grab"
                                cdkDrag
                                [cdkDragData]="{ type: 'rule1', data: rule }"
                                cdkDragRootElement=".drag-component"
                                cdkDragHandle
                            >reorder</mat-icon>

                            <mat-icon
                                style="margin-left: 6px; cursor: pointer;"
                                (click)="onDeleteRuleTypeIndex(rule)"
                                matTooltip="Delete Rule"
                                matTooltipPosition="above"
                                #deleteTooltip="matTooltip"
                                (mouseenter)="deleteTooltip.show(); reorderTooltip.hide()"
                                (mouseleave)="deleteTooltip.hide()"
                                class="red-icon"
                            >delete_forever</mat-icon>
                                </div>
                                <!-- <div>{{RuleTypeUtil.toString(rule.ruleType)}}</div> -->
                             </ng-container>
                             <ng-template #subheader>
                                <ng-container *ngIf="rule.isSubHeader; else defaultCase">
                                    <mat-icon
                                    cdkDrag
                                    [cdkDragData]="{ type: 'rule1', data: rule }"
                                    cdkDragRootElement=".drag-component"
                                    cdkDragHandle
                                    ></mat-icon>
                                </ng-container>
                             </ng-template>
                             <ng-template #defaultCase>
                            </ng-template>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="actions">
                        <th mat-header-cell *matHeaderCellDef class="no-padding-cell" style="width: 120px;">Actions</th>
                        <td mat-cell *matCellDef="let rule" class="no-padding-cell" style="width: 120px;">
                            <ng-container *ngIf="rule.isGroup; else subheader">
                                <div style="width: 120px;color: steelblue;">{{rule.actions}}</div>
                             </ng-container>
                             <ng-template #subheader>
                                <ng-container *ngIf="rule.isSubHeader; else defaultCase">

                                </ng-container>
                             </ng-template>
                             <ng-template #defaultCase>
                                <div style="display: flex; flex-direction: row; justify-content: flex-start; align-items: center">
                                    <!--<mat-icon color="primary" matTooltip="Re-order Rule"  style="cursor: grab" cdkDrag [cdkDragData]="{ type: 'rule2', data: rule }"
                                        cdkDragRootElement=".drag-component" cdkDragHandle>reorder</mat-icon>
                                    <mat-icon style="margin-left: 2px; cursor: pointer;" matTooltip="Add Rule" color="white" (click)="addSubRule(rule)">add_circle</mat-icon>
                                    <mat-icon style="margin-left: 4px; cursor: pointer" class="icon" (click)="onDuplicateRule(rule)" matTooltip="Duplicate Rule" color="primary">control_point_duplicate</mat-icon>
                                    <mat-icon style="margin-left: 2px; cursor: pointer" (click)="onDeleteRule(rule)" matTooltip="Delete Rule" class="red-icon">delete_forever</mat-icon>
                                -->
                                <mat-icon
                                color="primary"
                                matTooltip="Re-order Rule"
                                matTooltipPosition="above"
                                #reorderTooltip="matTooltip"
                                (mouseenter)="reorderTooltip.show(); addTooltip.hide(); duplicateTooltip.hide(); deleteTooltip.hide()"
                                (mouseleave)="reorderTooltip.hide()"
                                style="cursor: grab"
                                cdkDrag
                                [cdkDragData]="{ type: 'rule2', data: rule }"
                                cdkDragRootElement=".drag-component"
                                cdkDragHandle
                              >reorder</mat-icon>
                            
                              <mat-icon
                                style="margin-left: 6px; cursor: pointer;"
                                matTooltip="Add Rule"
                                matTooltipPosition="above"
                                #addTooltip="matTooltip"
                                (mouseenter)="addTooltip.show(); reorderTooltip.hide(); duplicateTooltip.hide(); deleteTooltip.hide()"
                                (mouseleave)="addTooltip.hide()"
                                color="white"
                                (click)="addSubRule(rule)"
                              >add_circle</mat-icon>
                            
                              <mat-icon
                                style="margin-left: 6px; cursor: pointer;"
                                class="icon"
                                matTooltip="Duplicate Rule"
                                matTooltipPosition="above"
                                #duplicateTooltip="matTooltip"
                                (mouseenter)="duplicateTooltip.show(); addTooltip.hide(); reorderTooltip.hide(); deleteTooltip.hide()"
                                (mouseleave)="duplicateTooltip.hide()"
                                color="primary"
                                (click)="onDuplicateRule(rule)"
                              >control_point_duplicate</mat-icon>
                            
                              <mat-icon
                                style="margin-left: 6px; cursor: pointer;"
                                matTooltip="Delete Rule"
                                matTooltipPosition="above"
                                #deleteTooltip="matTooltip"
                                (mouseenter)="deleteTooltip.show(); addTooltip.hide(); duplicateTooltip.hide(); reorderTooltip.hide()"
                                (mouseleave)="deleteTooltip.hide()"
                                class="red-icon"
                                (click)="onDeleteRule(rule)"
                              >delete_forever</mat-icon>
                                  
                                </div>
                             </ng-template>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="index">
                        <th mat-header-cell *matHeaderCellDef style="width: 40px;"> Rule </th>
                        <td mat-cell *matCellDef="let rule" style="width: 40px;color:#ECECEC;"> 
                            <ng-container *ngIf="rule.isGroup; else subheader">
                                <span>{{rule.index}}</span>
                             </ng-container>
                             <ng-template #subheader>
                                <ng-container *ngIf="rule.isSubHeader; else defaultCase">

                                </ng-container>
                             </ng-template>
                             <ng-template #defaultCase>
                                {{rule.index}}
                             </ng-template>
                        </td>
                        <mat-icon cdkDragHandle>reorder</mat-icon>
                    </ng-container>

                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef style="white-space: nowrap;width: 150px;"> Rule Name </th>
                        <td mat-cell *matCellDef="let rule" style="white-space: nowrap;width: 150px;">
                            <ng-container *ngIf="rule.isGroup; else subheader">
                               <span>{{rule.name}}</span>
                             </ng-container>
                             <ng-template #subheader>
                                <ng-container *ngIf="rule.isSubHeader; else defaultCase">

                                </ng-container>
                             </ng-template>
                             <ng-template #defaultCase>
                                <input type="text" style="border: none; box-sizing: border-box;color:#ECECEC;" [(ngModel)]="rule.ruleName" appAutowidth>
                             </ng-template>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="sourcefields">
                        <th mat-header-cell *matHeaderCellDef style="white-space: nowrap;"> Source Field(s) </th>
                        <td mat-cell *matCellDef="let rule" style="white-space: nowrap;"[attr.colspan]="rule.ruleType === RuleType.moveColumns ? 3 : 1">
                            <ng-container *ngIf="rule.isGroup; else subheader">
                                <span>{{rule.sourcefields}}</span>
                            </ng-container>
                            <ng-template #subheader>
                                <ng-container *ngIf="rule.isSubHeader; else deleteRows">

                                </ng-container>
                             </ng-template>
                            <ng-template #deleteRows>
                                <ng-container *ngIf="rule.ruleType === RuleType.deleteRows; else deDuplicate">
                                    <ng-container *ngIf="!rule.criteria && rule.criteria!=0; else criteriacond">
                                        <span style="margin-left: 2px; margin-right: 2px; color: #aaa; font-size:10px; white-space: pre;">
                                            Select Criteria >>
                                        </span>
                                    </ng-container>
                                    <ng-template #criteriacond>
                                        <div style="cursor: pointer" class="fixed-width-column text-overflow" (click)="onRuleFieldSelectCellClicked(rule)">
                                            <span *ngIf="rule.fields?.length === 0"
                                            style="margin-left: 2px; margin-right: 2px; color: #ffa600; font-size:10px; white-space: pre;">Tap to Edit</span>
                                        <span style="margin-left: 2px; margin-right: 2px; white-space: pre;" 
                                            *ngFor="let containItem of rule.fields"
                                            [style.color]="containItem.color.color">{{containItem.text }} </span>
                                        </div>
                                    </ng-template>
                                </ng-container>
                            </ng-template>
                            <ng-template #deDuplicate>
                                <ng-container *ngIf="rule.ruleType === RuleType.deDuplicate; else splitColumns">
                                    <div style="cursor: pointer" class="fixed-width-column text-overflow" (click)="onRuleFieldSelectCellClickedDeDuplicate(rule)">
                                        <span *ngIf="rule.fields?.length === 0"
                                        style="margin-left: 2px; margin-right: 2px; color: #ffa600; font-size:10px; white-space: pre;">Tap to Edit</span>
                                        <ng-container *ngIf="rule.fields?.length === 1 && (rule.fields[0].text=='All' || rule.fields[0].text=='None'); else greycolor">
                                            <span style="margin-left: 2px; margin-right: 2px; white-space: pre;" 
                                                *ngFor="let containItem of rule.fields" style="color:grey">{{containItem.text }} </span>
                                        </ng-container>
                                        <ng-template #greycolor>
                                            <span style="margin-left: 2px; margin-right: 2px; white-space: pre;" 
                                                *ngFor="let containItem of rule.fields"
                                                [style.color]="containItem.color.color">{{containItem.text }} </span>
                                        </ng-template>
                                    </div>
                                </ng-container>
                            </ng-template>
                            <ng-template #splitColumns>
                                <ng-container *ngIf="rule.ruleType === RuleType.splitColumns; else moveColumns">
                                    <mat-select [(ngModel)]="rule.splitField" placeholder="Select Source Field">
                                        <mat-select-trigger [ngStyle]="{'color': NamedColorList[0].color}">{{ rule.splitField }}</mat-select-trigger>
                                        <mat-option *ngFor="let col of viewModel.sourceColumns" [value]="col.text">{{col.text}}
                                        </mat-option>
                                    </mat-select>
                                </ng-container>
                            </ng-template>
                            <ng-template #moveColumns>
                                <ng-container *ngIf="rule.ruleType === RuleType.moveColumns; else splitintowords">
                                    <div style="cursor: pointer;" class="fixed-width-column-colspan text-overflow" (click)="onMoveColumnsCellClicked(rule)">
                                        <span *ngIf="rule.moveColumns.length === 0"
                                            style="margin-left: 2px; margin-right: 2px; color: #b8b8b8; font-size:10px; white-space: pre;">Add Source Field > Target Field pair</span>
                                        <span style="margin-left: 2px; margin-right: 2px; white-space: pre;" 
                                            *ngFor="let containItem of rule.moveColumns" [style.color]="containItem.color.color">{{containItem.find }} > {{containItem.replace}} </span>
                                    </div>
                                </ng-container>
                            </ng-template>
                            <ng-template #splitintowords>
                                <ng-container *ngIf="rule.ruleType === RuleType.splitintowords; else removeChars">
                                    <mat-select [(ngModel)]="rule.splitField" placeholder="Select Source Field">
                                        <mat-select-trigger [ngStyle]="{'color': NamedColorList[0].color}">{{ rule.splitField }}</mat-select-trigger>
                                        <mat-option *ngFor="let col of sourceColumnsString" [value]="col.text">{{col.text}}
                                        </mat-option>
                                    </mat-select>
                                </ng-container>
                            </ng-template>
                            <ng-template #removeChars>
                                <ng-container *ngIf="rule.ruleType === RuleType.removeChars; else defaultCase">
                                    <mat-select [(ngModel)]="rule.splitField" placeholder="Select Source Field">
                                        <mat-select-trigger [ngStyle]="{'color': NamedColorList[0].color}">{{ rule.splitField }}</mat-select-trigger>
                                        <mat-option *ngFor="let col of sourceColumnsString" [value]="col.text">{{col.text}}
                                        </mat-option>
                                    </mat-select>
                                </ng-container>
                            </ng-template>
                            <ng-template #defaultCase>
                                <div style="cursor: pointer" class="fixed-width-column text-overflow" (click)="onRuleFieldSelectCellClicked(rule)">
                                    <span *ngIf="rule.fields?.length === 0"
                                    style="margin-left: 2px; margin-right: 2px; color: #ffa600; font-size:10px; white-space: pre;">Tap to Edit</span>
                                <span style="margin-left: 2px; margin-right: 2px; white-space: pre;" 
                                    *ngFor="let containItem of rule.fields"
                                    [style.color]="containItem.color.color">{{containItem.text }} </span>
                                </div>
                            </ng-template>
                        </td>
                        <mat-icon cdkDragHandle>reorder</mat-icon>
                    </ng-container>

                    <ng-container matColumnDef="additional1">
                        <th mat-header-cell *matHeaderCellDef>Additional 1</th>
                        <ng-container *matCellDef="let rule">
                            <td mat-cell  *ngIf="rule.ruleType != RuleType.moveColumns" >
                                <ng-container *ngIf="rule.isGroup; else subheader">
                                    <span>{{rule.additional1}}</span>
                                </ng-container>
                                <ng-template #subheader>
                                    <ng-container *ngIf="rule.isSubHeader; else findReplaceAdv">

                                    </ng-container>
                                </ng-template>
                                <ng-template #findReplaceAdv>
                                    <ng-container *ngIf="rule.ruleType === RuleType.findReplaceAdv; else defaultCase">
                                        <div style="cursor: pointer;" class="fixed-width-column text-overflow" (click)="onFindReplaceCellClicked(rule)">
                                            <span *ngIf="rule.findReplace?.length === 0"
                                                style="margin-left: 2px; margin-right: 2px; color: #b8b8b8; font-size:10px; white-space: pre;">Add Find > Replace</span>
                                            <span style="margin-left: 2px; margin-right: 2px; white-space: pre;" 
                                                *ngFor="let containItem of rule.findReplace" [style.color]="containItem.color.color">{{containItem.find }} > {{containItem.replace}} </span>
                                        </div>
                                    </ng-container>
                                    <ng-template #defaultCase>
                                    </ng-template>
                                </ng-template>
                            </td>
                        </ng-container>
                    </ng-container>

                    <ng-container matColumnDef="criteria">
                        <th mat-header-cell *matHeaderCellDef style="white-space: nowrap;"> Criteria </th>
                        <ng-container *matCellDef="let rule">
                            <td mat-cell *ngIf="rule.ruleType != RuleType.moveColumns" style="white-space: nowrap;" [attr.colspan]="rule.ruleType === RuleType.findReplace ? 5 : 1">
                                <ng-container *ngIf="rule.isGroup; else subheader">
                                    <span>{{rule.criteria}}</span>
                                </ng-container>
                                <ng-template #subheader>
                                    <ng-container *ngIf="rule.isSubHeader; else deleteRows">

                                    </ng-container>
                                </ng-template>
                                <ng-template #deleteRows>
                                    <ng-container *ngIf="rule.ruleType === RuleType.deleteRows; else deDuplicate">
                                        <mat-select [(ngModel)]="rule.criteria" (click)="storePreviousValue(rule.criteria)" (selectionChange)="onCriteriaChange(rule)" placeholder="Select Criteria">
                                            <mat-option *ngFor="let criteria of Criterias" [value]="criteria">
                                                {{CriteriaUtil.toString(criteria)}}
                                            </mat-option>
                                        </mat-select>
                                    </ng-container>
                                </ng-template>
                                <ng-template #deDuplicate>
                                    <ng-container *ngIf="rule.ruleType === RuleType.deDuplicate; else findReplace">
                                        <mat-select [(ngModel)]="rule.duplicatesType" (selectionChange)="onChangeType(rule)">
                                            <mat-option *ngFor="let duplicateType of DuplicateTypes" [value]="duplicateType">
                                                {{DuplicateTypeUtil.toString(duplicateType)}}
                                            </mat-option>
                                        </mat-select>
                                    </ng-container>
                                </ng-template>
                                <ng-template #findReplace>
                                    <ng-container *ngIf="rule.ruleType === RuleType.findReplace; else findReplaceAdv">
                                        <div style="cursor: pointer;" class="fixed-width-column-colspan text-overflow" (click)="onFindReplaceCellClicked(rule)">
                                            <span *ngIf="rule.findReplace?.length === 0"
                                                style="margin-left: 2px; margin-right: 2px; color: #b8b8b8; font-size:10px; white-space: pre;">Add Find > Replace</span>
                                            <span style="margin-left: 2px; margin-right: 2px; white-space: pre;" 
                                                *ngFor="let containItem of rule.findReplace" [style.color]="containItem.color.color">{{containItem.find }} > {{containItem.replace}} </span>
                                        </div>
                                    </ng-container>
                                </ng-template>
                                <ng-template #findReplaceAdv>
                                    <ng-container *ngIf="rule.ruleType === RuleType.findReplaceAdv; else deleteColumns">
                                        <mat-slide-toggle color="primary" [(ngModel)]="rule.matchAll"></mat-slide-toggle>
                                    </ng-container>
                                </ng-template>
                                <ng-template #deleteColumns>
                                    <ng-container *ngIf="rule.ruleType === RuleType.deleteColumns; else combineColumns">
                                        <mat-select [(ngModel)]="rule.deleteWhenEmpty">
                                            <mat-option [value]="0">0%</mat-option>
                                            <mat-option [value]="0.1">10%</mat-option>
                                            <mat-option [value]="0.25">25%</mat-option>
                                            <mat-option [value]="0.5">50%</mat-option>
                                            <mat-option [value]="0.8">80%</mat-option>
                                            <mat-option [value]="0.9">90%</mat-option>
                                            <mat-option [value]="0.95">95%</mat-option>
                                            <mat-option [value]="0.99">99%</mat-option>
                                            <mat-option [value]="1">100%</mat-option>
                                        </mat-select>
                                    </ng-container>
                                </ng-template>
                                <ng-template #combineColumns>
                                    <ng-container *ngIf="rule.ruleType === RuleType.combineColumns; else splitColumns">
                                        <mat-select [(ngModel)]="rule.separator" >
                                            <mat-option *ngFor="let separator of SeparatorNones" [value]="separator">
                                                {{SeparatorNoneUtil.toString(separator)}}
                                            </mat-option>
                                        </mat-select>
                                        <!-- <app-autocomplete-field-separator 
                                            [(ngModel)]="rule.separator">
                                        </app-autocomplete-field-separator> -->
                                    </ng-container>
                                </ng-template>
                                <ng-template #splitColumns>
                                    <ng-container *ngIf="rule.ruleType === RuleType.splitColumns; else formatColumns">
                                        <mat-select [(ngModel)]="rule.separator" >
                                            <mat-option *ngFor="let separator of SeparatorWithoutOutNones" [value]="separator">
                                                {{SeparatorNoneUtil.toString(separator)}}
                                            </mat-option>
                                        </mat-select>
                                        <!-- <app-autocomplete-field-separator 
                                            [(ngModel)]="rule.separator">
                                        </app-autocomplete-field-separator> -->
                                    </ng-container>
                                </ng-template>
                                <ng-template #formatColumns>
                                    <ng-container *ngIf="rule.ruleType === RuleType.formatColumns; else splitintowords">
                                        <mat-select [(ngModel)]="rule.formatAs">
                                            <mat-option *ngFor="let formatas of FormatAss" [value]="formatas">
                                                {{FormatAsUtil.toString(formatas)}}
                                            </mat-option>
                                        </mat-select>
                                    </ng-container>
                                </ng-template>
                                <ng-template #splitintowords>
                                    <ng-container *ngIf="rule.ruleType === RuleType.splitintowords; else removeChars">
                                        <mat-select [(ngModel)]="rule.targetField" placeholder="Select Target Field">
                                            <mat-select-trigger [ngStyle]="{'color': NamedColorList[0].color}">{{ rule.targetField }}</mat-select-trigger>
                                            <mat-option *ngFor="let col of targetColumnsString" [value]="col.text">{{col.text}}
                                            </mat-option>
                                        </mat-select>
                                    </ng-container>
                                </ng-template>
                                <ng-template #removeChars>
                                    <ng-container *ngIf="rule.ruleType === RuleType.removeChars; else defaultCase">
                                        <mat-select [(ngModel)]="rule.targetField" placeholder="Select Target Field">
                                            <mat-select-trigger [ngStyle]="{'color': NamedColorList[0].color}">{{ rule.targetField }}</mat-select-trigger>
                                            <mat-option *ngFor="let col of targetColumnsString" [value]="col.text">{{col.text}}
                                            </mat-option>
                                        </mat-select>
                                    </ng-container>
                                </ng-template>
                                <ng-template #defaultCase>
                                
                                </ng-template>
                            </td>
                        </ng-container>
                        <mat-icon cdkDragHandle>reorder</mat-icon>
                    </ng-container>

                    <ng-container matColumnDef="matchvalues">
                        <th mat-header-cell *matHeaderCellDef> Match value(s) </th>
                        <ng-container *matCellDef="let rule">
                            <td mat-cell  *ngIf="rule.ruleType != RuleType.findReplace" 
                            [ngStyle]="rule.ruleType === RuleType.findReplaceAdv ? {'border-left': '2px solid #ffa600'} : {}"
                            [attr.colspan]="rule.isSubHeader ? 4 : 1">
                                <ng-container *ngIf="rule.isGroup; else subheader">
                                    <span>{{rule.matchvalues}}</span>
                                </ng-container>
                                <ng-template #subheader>
                                    <ng-container *ngIf="rule.isSubHeader; else deleteRows">
                                       <div> Supplemental Conditions </div>
                                    </ng-container>
                                </ng-template>
                                <ng-template #deleteRows>
                                    <ng-container *ngIf="rule.ruleType === RuleType.deleteRows; else deDuplicate">
                                        <ng-container *ngIf="MatchValueEntryEditor(rule.criteria,rule.andOr)==MatchValueEntryType.multiSingle; else multientry">
                                            <div style="cursor: pointer" class="fixed-width-column text-overflow" (click)="onRuleMatchValueSelectCellClicked(rule)">
                                                <span *ngIf="rule.matchValue?.length === 0"
                                                    style="margin-left: 2px; margin-right: 2px; color: #ffa600; font-size:10px; white-space: pre;">Tap to Edit</span>
                                                <span style="margin-left: 2px; margin-right: 2px; white-space: pre;" 
                                                    *ngFor="let containItem of rule.matchValue"
                                                    [style.color]="containItem.color.color">{{containItem.text }} </span>
                                            </div>
                                        </ng-container>
                                        <ng-template #multientry>
                                            <ng-container *ngIf=" MatchValueEntryEditor(rule.criteria,rule.andOr)==MatchValueEntryType.multiMulti; else valueentry">
                                                <div style="cursor: pointer" class="fixed-width-column text-overflow" (click)="onRuleMatchValueSelectCellClickedTextEntry(rule)">
                                                    <span *ngIf="rule.matchValue?.length === 0"
                                                        style="margin-left: 2px; margin-right: 2px; color: #ffa600; font-size:10px; white-space: pre;">Tap to Edit</span>
                                                    <span style="margin-left: 2px; margin-right: 2px; white-space: pre;" 
                                                        *ngFor="let containItem of rule.matchValue"
                                                        [style.color]="containItem.color.color">{{containItem.text}} </span>
                                                </div>
                                            </ng-container>
                                        </ng-template>
                                        <ng-template #valueentry>
                                            <ng-container *ngIf="(MatchValueEntryEditor(rule.criteria,rule.andOr)==MatchValueEntryType.valueSingle || MatchValueEntryEditor(rule.criteria,rule.andOr)==MatchValueEntryType.valueMulti); else rangeentry">
                                                <div style="cursor: pointer" class="fixed-width-column text-overflow" (click)="onRuleMatchValueSelectCellClickedValueEntry(rule)">
                                                    <span *ngIf="rule.matchValue?.length === 0"
                                                        style="margin-left: 2px; margin-right: 2px; color: #ffa600; font-size:10px; white-space: pre;">Tap to Edit</span>
                                                    <span style="margin-left: 2px; margin-right: 2px; white-space: pre;" 
                                                        *ngFor="let containItem of rule.matchValue"
                                                        [style.color]="containItem.color.color"><span style="color: #ECECEC;">{{CriteriaUtilSymbol.toString(rule.criteria)}} </span>{{containItem.text}} </span>
                                                </div>
                                            </ng-container>
                                        </ng-template>
                                        <ng-template #rangeentry>
                                            <ng-container *ngIf="(MatchValueEntryEditor(rule.criteria,rule.andOr)==MatchValueEntryType.rangeSingle || MatchValueEntryEditor(rule.criteria,rule.andOr)==MatchValueEntryType.rangeMulti); else defaultMatchValue">
                                                <div style="cursor: pointer" class="fixed-width-column text-overflow" (click)="onRuleMatchValueSelectCellClickedRangeEntry(rule)">
                                                    <span *ngIf="rule.matchValueList?.length === 0"
                                                        style="margin-left: 2px; margin-right: 2px; color: #ffa600; font-size:10px; white-space: pre;">Tap to Edit</span>
                                                    <span style="margin-left: 2px; margin-right: 2px; white-space: pre;" 
                                                        *ngFor="let containItem of rule.matchValueList" [style.color]="containItem.color.color">
                                                        {{containItem.find }} <span *ngIf="rule.matchValueList?.length > 0" style="color: #ECECEC;">{{ CriteriaUtilSymbol.toString(rule.criteria) }}</span> {{containItem.replace}} </span>
                                                </div>
                                            </ng-container>
                                        </ng-template>
                                        <ng-template #defaultMatchValue>
                                            <!-- <span style="margin-left: 2px; margin-right: 2px; color: #aaa; font-size:10px; white-space: pre;">
                                                &lt;Disabled&gt;
                                            </span> -->
                                            <div style="cursor: pointer" class="disable">
                                                <span *ngIf="rule.matchValue?.length === 0"
                                                    style="margin-left: 2px; margin-right: 2px; font-size:10px; white-space: pre;">Tap to Edit</span>
                                            </div>
                                        </ng-template>
                                        <!-- <span style="margin-left: 2px; margin-right: 2px; color: #aaa; font-size:10px; white-space: pre;">
                                            &lt;NA&gt;
                                        </span> -->
                                        <!-- <input type="text" style="border: none; box-sizing: border-box" [(ngModel)]="rule.matchValue" appAutowidth> -->
                                    </ng-container>
                                </ng-template>
                                <ng-template #deDuplicate>
                                    <ng-container *ngIf="rule.ruleType === RuleType.deDuplicate; else combineColumns">
                                        <mat-select [(ngModel)]="rule.duplicatesKeep" >
                                            <mat-option *ngFor="let duplicateKeep of DuplicateKeeps" [value]="duplicateKeep">
                                                {{DuplicateKeepUtil.toString(duplicateKeep)}}
                                            </mat-option>
                                        </mat-select>
                                    </ng-container>
                                </ng-template>
                                <ng-template #combineColumns>
                                    <ng-container *ngIf="rule.ruleType === RuleType.combineColumns; else splitColumns">
                                        <mat-select [(ngModel)]="rule.targetField" placeholder="Select Target Field">
                                            <mat-option></mat-option>
                                            <mat-option *ngFor="let col of viewModel.targetColumns" [value]="col">{{col}}
                                            </mat-option>
                                        </mat-select>
                                    </ng-container>
                                </ng-template>
                                <ng-template #splitColumns>
                                    <ng-container *ngIf="rule.ruleType === RuleType.splitColumns; else formatColumns">
                                        <input type="number" style="border: none; box-sizing: border-box" [(ngModel)]="rule.maxColumns" appAutowidth [min]="2" [max]="19" appIntegerPositiveOnly required>
                                    </ng-container>
                                </ng-template>
                                <ng-template #formatColumns>
                                    <ng-container *ngIf="rule.ruleType === RuleType.formatColumns; else findReplaceAdv">
                                        <input type="number" style="border: none; box-sizing: border-box" [(ngModel)]="rule.noChars" appAutowidth appIntegerPositiveOnly >
                                    </ng-container>
                                </ng-template>
                                <ng-template #findReplaceAdv>
                                    <ng-container *ngIf="rule.ruleType === RuleType.findReplaceAdv; else splitintowords">
                                        <ng-container *ngIf="rule.criteria!=Criteria.none; else disableContent">
                                            <ng-container *ngIf="!rule.criteria && rule.criteria!=0; else criteriacond">
                                                <span style="margin-left: 2px; margin-right: 2px; color: #aaa; font-size:10px; white-space: pre;">
                                                    Select Criteria >>
                                                </span>
                                            </ng-container>
                                            <ng-template #criteriacond>
                                                <div style="cursor: pointer" class="fixed-width-column text-overflow" (click)="onRuleFieldSelectCellClickedConditional(rule)">
                                                    <span *ngIf="rule.conditionalFields?.length === 0"
                                                    style="margin-left: 2px; margin-right: 2px; color: #ffa600; font-size:10px; white-space: pre;">Tap to Edit</span>
                                                <span style="margin-left: 2px; margin-right: 2px; white-space: pre;" 
                                                    *ngFor="let containItem of rule.conditionalFields"
                                                    [style.color]="containItem.color.color">{{containItem.text }} </span>
                                                </div>
                                            </ng-template>
                                        </ng-container>
                                        <ng-template #disableContent>
                                            <div style="cursor: pointer" class="disable">
                                                <span *ngIf="rule.matchValue?.length === 0"
                                                    style="margin-left: 2px; margin-right: 2px; font-size:10px; white-space: pre;">Tap to Edit</span>
                                            </div>
                                        </ng-template>
                                    </ng-container>
                                </ng-template>
                                <ng-template #splitintowords>
                                    <ng-container *ngIf="rule.ruleType === RuleType.splitintowords; else removeChars">
                                        <mat-select [(ngModel)]="rule.articleOption" placeholder="Select Articles">
                                            <mat-option *ngFor="let preposition of Prepositionss" [value]="preposition">
                                                {{PrepositionsUtil.toString(preposition)}}
                                            </mat-option>
                                        </mat-select>
                                    </ng-container>
                                </ng-template>
                                <ng-template #removeChars>
                                    <ng-container *ngIf="rule.ruleType === RuleType.removeChars; else defaultCase">
                                        <app-autocomplete-field-separator 
                                            [(ngModel)]="rule.removeChars">
                                        </app-autocomplete-field-separator>
                                    </ng-container>
                                </ng-template>
                                <ng-template #defaultCase>
                                
                                </ng-template>
                            </td>
                        </ng-container>
                    </ng-container>

                    <ng-container matColumnDef="additional2">
                        <th mat-header-cell *matHeaderCellDef>Additional 2</th>
                        <ng-container *matCellDef="let rule">
                            <ng-container *ngIf="!rule.isSubHeader">
                                <td mat-cell *ngIf="rule.ruleType != RuleType.findReplace">
                                    <ng-container *ngIf="rule.isGroup; else subheader">
                                        <span>{{rule.additional2}}</span>
                                    </ng-container>
                                    <ng-template #subheader>
                                        <ng-container *ngIf="rule.isSubHeader; else findReplaceAdv">

                                        </ng-container>
                                    </ng-template>
                                    <ng-template #findReplaceAdv>
                                        <ng-container *ngIf="rule.ruleType === RuleType.findReplaceAdv; else splitintowords">
                                            <mat-select [(ngModel)]="rule.criteria" (click)="storePreviousValue(rule.criteria)" (selectionChange)="onCriteriaChangeAdv(rule)" placeholder="Select Criteria">
                                                <mat-option *ngFor="let criteria of CriteriasAdv" [value]="criteria">
                                                    {{CriteriaUtil.toString(criteria)}}
                                                </mat-option>
                                            </mat-select>
                                        </ng-container>
                                    </ng-template>
                                    <ng-template #splitintowords>
                                        <ng-container *ngIf="rule.ruleType === RuleType.splitintowords; else defaultCase">
                                            <mat-select [(ngModel)]="rule.conjunctionOption" placeholder="Select Conjunctions">
                                                <mat-option *ngFor="let preposition of Prepositionss" [value]="preposition">
                                                    {{PrepositionsUtil.toString(preposition)}}
                                                </mat-option>
                                            </mat-select>
                                        </ng-container>
                                    </ng-template>
                                    <ng-template #defaultCase>
                                    </ng-template> 
                                </td>
                            </ng-container>
                        </ng-container>
                    </ng-container>

                    <ng-container matColumnDef="ifmatched">
                        <th mat-header-cell *matHeaderCellDef style="white-space: nowrap;"> If matched </th>
                        <ng-container *matCellDef="let rule">
                        <ng-container *ngIf="!rule.isSubHeader">
                        <td mat-cell *ngIf="rule.ruleType != RuleType.findReplace" style="white-space: nowrap;">
                            <ng-container *ngIf="rule.isGroup; else subheader">
                                <span>{{rule.ifmatched}}</span>
                            </ng-container>
                            <ng-template #subheader>
                                <ng-container *ngIf="rule.isSubHeader; else deleteRows">

                                </ng-container>
                            </ng-template>
                            <ng-template #deleteRows>
                                <ng-container *ngIf="rule.ruleType === RuleType.deleteRows; else combineColumns">
                                    <mat-select [(ngModel)]="rule.ifMatched">
                                        <!-- <mat-option></mat-option> -->
                                        <mat-option [value]=true>Delete Rows</mat-option>
                                        <mat-option [value]=false>Keep Rows</mat-option>
                                    </mat-select>
                                </ng-container>
                            </ng-template>                           
                            <ng-template #combineColumns>
                                <ng-container *ngIf="rule.ruleType === RuleType.combineColumns; else splitColumns">
                                    <input type="text" style="border: none; box-sizing: border-box" [(ngModel)]="rule.emptyFieldValue" appAutowidth>
                                </ng-container>
                             </ng-template>
                             <ng-template #splitColumns>
                                <ng-container *ngIf="rule.ruleType === RuleType.splitColumns; else formatColumns">
                                    <!-- <input type="text" style="border: none; box-sizing: border-box" [(ngModel)]="rule.colBaseName"> -->
                                </ng-container>
                             </ng-template>
                             <ng-template #formatColumns>
                                <ng-container *ngIf="rule.ruleType === RuleType.formatColumns; else findReplaceAdv">
                                    <input type="number" style="border: none; box-sizing: border-box" [(ngModel)]="rule.startPos" appAutowidth appIntegerPositiveOnly >
                                </ng-container>
                             </ng-template>
                            <ng-template #findReplaceAdv>
                                <ng-container *ngIf="rule.ruleType === RuleType.findReplaceAdv; else splitintowords">
                                    <ng-container *ngIf="MatchValueEntryEditor(rule.criteria,rule.andOr)==MatchValueEntryType.multiSingle; else multientry">
                                        <div style="cursor: pointer" class="fixed-width-column text-overflow" (click)="onRuleMatchValueSelectCellClicked(rule)">
                                            <span *ngIf="rule.matchValue?.length === 0"
                                                style="margin-left: 2px; margin-right: 2px; color: #ffa600; font-size:10px; white-space: pre;">Tap to Edit</span>
                                            <span style="margin-left: 2px; margin-right: 2px; white-space: pre;" 
                                                *ngFor="let containItem of rule.matchValue"
                                                [style.color]="containItem.color.color">{{containItem.text }} </span>
                                        </div>
                                    </ng-container>
                                    <ng-template #multientry>
                                        <ng-container *ngIf=" MatchValueEntryEditor(rule.criteria,rule.andOr)==MatchValueEntryType.multiMulti; else valueentry">
                                            <div style="cursor: pointer" class="fixed-width-column text-overflow" (click)="onRuleMatchValueSelectCellClickedTextEntry(rule)">
                                                <span *ngIf="rule.matchValue?.length === 0"
                                                    style="margin-left: 2px; margin-right: 2px; color: #ffa600; font-size:10px; white-space: pre;">Tap to Edit</span>
                                                <span style="margin-left: 2px; margin-right: 2px; white-space: pre;" 
                                                    *ngFor="let containItem of rule.matchValue"
                                                    [style.color]="containItem.color.color">{{containItem.text}} </span>
                                            </div>
                                        </ng-container>
                                    </ng-template>
                                    <ng-template #valueentry>
                                        <ng-container *ngIf="(MatchValueEntryEditor(rule.criteria,rule.andOr)==MatchValueEntryType.valueSingle || MatchValueEntryEditor(rule.criteria,rule.andOr)==MatchValueEntryType.valueMulti); else rangeentry">
                                            <div style="cursor: pointer" class="fixed-width-column text-overflow" (click)="onRuleMatchValueSelectCellClickedValueEntry(rule)">
                                                <span *ngIf="rule.matchValue?.length === 0"
                                                    style="margin-left: 2px; margin-right: 2px; color: #ffa600; font-size:10px; white-space: pre;">Tap to Edit</span>
                                                <span style="margin-left: 2px; margin-right: 2px; white-space: pre;" 
                                                    *ngFor="let containItem of rule.matchValue"
                                                    [style.color]="containItem.color.color"><span style="color: #ECECEC;">{{CriteriaUtilSymbol.toString(rule.criteria)}} </span>{{containItem.text}} </span>
                                            </div>
                                        </ng-container>
                                    </ng-template>
                                    <ng-template #rangeentry>
                                        <ng-container *ngIf="(MatchValueEntryEditor(rule.criteria,rule.andOr)==MatchValueEntryType.rangeSingle || MatchValueEntryEditor(rule.criteria,rule.andOr)==MatchValueEntryType.rangeMulti); else defaultMatchValue">
                                            <div style="cursor: pointer" class="fixed-width-column text-overflow" (click)="onRuleMatchValueSelectCellClickedRangeEntry(rule)">
                                                <span *ngIf="rule.matchValueList?.length === 0"
                                                    style="margin-left: 2px; margin-right: 2px; color: #ffa600; font-size:10px; white-space: pre;">Tap to Edit</span>
                                                <span style="margin-left: 2px; margin-right: 2px; white-space: pre;" 
                                                    *ngFor="let containItem of rule.matchValueList" [style.color]="containItem.color.color">
                                                    {{containItem.find }} <span *ngIf="rule.matchValueList?.length > 0" style="color: #ECECEC;">{{ CriteriaUtilSymbol.toString(rule.criteria) }}</span> {{containItem.replace}} </span>
                                            </div>
                                        </ng-container>
                                    </ng-template>
                                    <ng-template #defaultMatchValue>
                                        <!-- <span style="margin-left: 2px; margin-right: 2px; color: #aaa; font-size:10px; white-space: pre;">
                                            &lt;Disabled&gt;
                                        </span> -->
                                        <div style="cursor: pointer" class="disable">
                                            <span *ngIf="rule.matchValue?.length === 0"
                                                style="margin-left: 2px; margin-right: 2px; font-size:10px; white-space: pre;">Tap to Edit</span>
                                        </div>
                                    </ng-template>
                                </ng-container>
                            </ng-template>
                            <ng-template #splitintowords>
                                <ng-container *ngIf="rule.ruleType === RuleType.splitintowords; else removeChars">
                                    <mat-select [(ngModel)]="rule.determinerOption" placeholder="Select Determiners">
                                        <mat-option *ngFor="let preposition of Prepositionss" [value]="preposition">
                                            {{PrepositionsUtil.toString(preposition)}}
                                        </mat-option>
                                    </mat-select>
                                </ng-container>
                            </ng-template>
                            <ng-template #removeChars>
                                <ng-container *ngIf="rule.ruleType === RuleType.removeChars; else defaultCase">
                                    <mat-select [(ngModel)]="rule.removeOption" placeholder="Select Remove Type">
                                        <mat-option *ngFor="let removeOption of RemoveOptions" [value]="removeOption">
                                            {{RemoveOptionUtil.toString(removeOption)}}
                                        </mat-option>
                                    </mat-select>
                                </ng-container>
                            </ng-template>
                            <ng-template #defaultCase>
                            </ng-template> 
                        </td>
                        </ng-container>
                        </ng-container>
                    </ng-container>

                    <ng-container matColumnDef="logicalOperator">
                        <th mat-header-cell *matHeaderCellDef style="width: 120px;"> AND/OR </th>
                        <ng-container *matCellDef="let rule">
                        <ng-container *ngIf="!rule.isSubHeader">
                        <td mat-cell *ngIf="rule.ruleType != RuleType.findReplace" style="width: 120px;">
                            <ng-container *ngIf="rule.isGroup; else subheader">
                                <span>{{rule.logicalOperator}}</span>
                             </ng-container>
                             <ng-template #subheader>
                                <ng-container *ngIf="rule.isSubHeader; else deleteRows">

                                </ng-container>
                            </ng-template>
                             <ng-template #deleteRows>
                                <ng-container *ngIf="rule.ruleType === RuleType.deleteRows; else combineColumns">
                                    <ng-container *ngIf="getGroupAndOrCriteria(rule.criteria)=='A'; else criteriaB">
                                        <mat-select [(ngModel)]="rule.andOr" (selectionChange)="onAndOrChange(rule)">
                                            <mat-option *ngFor="let andOr of AndOrsA" [value]="andOr">
                                                {{AndOrUtil.toString(andOr)}}
                                            </mat-option>
                                        </mat-select>
                                    </ng-container>
                                    <ng-template #criteriaB>
                                        <ng-container *ngIf="getGroupAndOrCriteria(rule.criteria)=='B'; else disableContent">
                                            <mat-select [(ngModel)]="rule.andOr" (selectionChange)="onAndOrChange(rule)">
                                                <mat-option *ngFor="let andOr of AndOrsB" [value]="andOr">
                                                    {{AndOrUtil.toString(andOr)}}
                                                </mat-option>
                                            </mat-select>
                                        </ng-container>
                                    </ng-template>
                                    <ng-template #disableContent>
                                        <mat-select disabled class="disable">
                                            <mat-option></mat-option>
                                        </mat-select>
                                    </ng-template>
                                </ng-container>
                             </ng-template>
                             <ng-template #combineColumns>
                                <ng-container *ngIf="rule.ruleType === RuleType.combineColumns; else splitColumns">
                                    <app-autocomplete-field-separator 
                                        [(ngModel)]="rule.removeChars">
                                    </app-autocomplete-field-separator>
                                </ng-container>
                             </ng-template>
                             <ng-template #splitColumns>
                                <ng-container *ngIf="rule.ruleType === RuleType.splitColumns; else findReplaceAdv">
                                    <app-autocomplete-field-separator 
                                        [(ngModel)]="rule.removeChars">
                                    </app-autocomplete-field-separator>
                                </ng-container>
                             </ng-template>
                             <ng-template #findReplaceAdv>
                                <ng-container *ngIf="rule.ruleType === RuleType.findReplaceAdv; else moveColumns">
                                    <ng-container *ngIf="getGroupAndOrCriteria(rule.criteria)=='A'; else criteriaB">
                                        <mat-select [(ngModel)]="rule.andOr" (selectionChange)="onAndOrChangeAdv(rule)">
                                            <mat-option *ngFor="let andOr of AndOrsA" [value]="andOr">
                                                {{AndOrUtil.toString(andOr)}}
                                            </mat-option>
                                        </mat-select>
                                    </ng-container>
                                    <ng-template #criteriaB>
                                        <ng-container *ngIf="getGroupAndOrCriteria(rule.criteria)=='B'; else disableContent">
                                            <mat-select [(ngModel)]="rule.andOr" (selectionChange)="onAndOrChangeAdv(rule)">
                                                <mat-option *ngFor="let andOr of AndOrsB" [value]="andOr">
                                                    {{AndOrUtil.toString(andOr)}}
                                                </mat-option>
                                            </mat-select>
                                        </ng-container>
                                    </ng-template>
                                    <ng-template #disableContent>
                                        <mat-select disabled class="disable">
                                            <mat-option></mat-option>
                                        </mat-select>
                                    </ng-template>
                                </ng-container>
                             </ng-template>
                             <ng-template #moveColumns>
                                <ng-container *ngIf="rule.ruleType === RuleType.moveColumns; else splitintowords">
                                    <mat-slide-toggle color="primary" [(ngModel)]="rule.overWriteData"></mat-slide-toggle>
                                </ng-container>
                             </ng-template>
                             <ng-template #splitintowords>
                                    <ng-container *ngIf="rule.ruleType === RuleType.splitintowords; else defaultCase">
                                        <mat-select [(ngModel)]="rule.prepOption" placeholder="Select Prepositions">
                                            <mat-option *ngFor="let preposition of Prepositionss" [value]="preposition">
                                                {{PrepositionsUtil.toString(preposition)}}
                                            </mat-option>
                                        </mat-select>
                                    </ng-container>
                                </ng-template>
                             <ng-template #defaultCase>
                               
                             </ng-template>
                        </td>
                        </ng-container>
                        </ng-container>
                    </ng-container>

                    <ng-container matColumnDef="matchCase">
                        <th mat-header-cell *matHeaderCellDef style="text-align: center;width: 120px;">
                            <div style="margin-bottom: 2px;">Match Case?</div>
                            <!-- <mat-slide-toggle
                                (change)="onMatchCaseChanged($event)"
                                color="primary">
                            </mat-slide-toggle> -->
                        </th>
                        <ng-container *matCellDef="let rule">
                        <td mat-cell style="text-align: center;width: 120px;">
                            <ng-container *ngIf="rule.isGroup; else subheader">
                                <span [innerHTML]="rule.matchCase"></span>
                             </ng-container>
                             <ng-template #subheader>
                                <ng-container *ngIf="rule.isSubHeader; else deleteRows">

                                </ng-container>
                            </ng-template>
                             <ng-template #deleteRows>
                                <ng-container *ngIf="rule.ruleType === RuleType.deleteRows; else deDuplicate">
                                    <ng-container *ngIf="rule.ruleType === RuleType.deleteRows; else combineColumns">
                                        <ng-container *ngIf="isDisabledMatch(rule.criteria); else editableContent">
                                            <mat-slide-toggle style="color: #555;" [(ngModel)]="rule.matchCase" disabled></mat-slide-toggle>
                                        </ng-container>
                                        <ng-template #editableContent>
                                            <mat-slide-toggle color="primary" [(ngModel)]="rule.matchCase"></mat-slide-toggle>
                                        </ng-template>
                                    </ng-container>
                                </ng-container>
                            </ng-template>
                            <ng-template #deDuplicate>
                                <ng-container *ngIf="rule.ruleType === RuleType.deDuplicate; else findReplace">
                                    <mat-slide-toggle color="primary" [(ngModel)]="rule.matchCase"></mat-slide-toggle>
                                </ng-container>
                            </ng-template>
                            <ng-template #findReplace>
                                <ng-container *ngIf="rule.ruleType === RuleType.findReplace; else combineColumns">
                                    <mat-slide-toggle color="primary" [(ngModel)]="rule.matchAll"></mat-slide-toggle>
                                    <!-- <mat-select [(ngModel)]="rule.matchAll">
                                         <mat-option></mat-option> 
                                        <mat-option [value]=true>Entire Field</mat-option>
                                        <mat-option [value]=false>Includes</mat-option>
                                    </mat-select> -->
                                </ng-container> 
                            </ng-template>
                            <ng-template #combineColumns>
                                <ng-container *ngIf="rule.ruleType === RuleType.combineColumns; else splitColumns">
                                    <mat-slide-toggle color="primary" [(ngModel)]="rule.keepOrigColumn"></mat-slide-toggle>
                                </ng-container>
                             </ng-template>
                             <ng-template #splitColumns>
                                <ng-container *ngIf="rule.ruleType === RuleType.splitColumns; else findReplaceAdv">
                                    <mat-slide-toggle color="primary" [(ngModel)]="rule.keepOrigColumn"></mat-slide-toggle>
                                </ng-container>
                             </ng-template>
                             <ng-template #findReplaceAdv>
                                <ng-container *ngIf="rule.ruleType === RuleType.findReplaceAdv; else moveColumns">
                                    <ng-container *ngIf="isDisabledMatch(rule.criteria); else editableContent">
                                        <mat-slide-toggle style="color: #555;" [(ngModel)]="rule.matchCase" disabled></mat-slide-toggle>
                                    </ng-container>
                                    <ng-template #editableContent>
                                        <mat-slide-toggle color="primary" [(ngModel)]="rule.matchCase"></mat-slide-toggle>
                                    </ng-template>
                                </ng-container>
                             </ng-template>
                             <ng-template #moveColumns>
                                <ng-container *ngIf="rule.ruleType === RuleType.moveColumns; else splitintowords">
                                    <mat-slide-toggle color="primary" [(ngModel)]="rule.keepOrigColumn"></mat-slide-toggle>
                                </ng-container>
                             </ng-template>
                             <ng-template #splitintowords>
                                <ng-container *ngIf="rule.ruleType === RuleType.splitintowords; else removeChars">
                                    <mat-slide-toggle color="primary" [(ngModel)]="rule.keepOrigColumn"></mat-slide-toggle>
                                </ng-container>
                             </ng-template>
                             <ng-template #removeChars>
                                <ng-container *ngIf="rule.ruleType === RuleType.removeChars; else defaultCase">
                                    <mat-slide-toggle color="primary" [(ngModel)]="rule.keepOrigColumn"></mat-slide-toggle>
                                </ng-container>
                             </ng-template>
                            <ng-template #defaultCase>
                               
                            </ng-template>
                        </td>
                        </ng-container>
                    </ng-container>

                    <ng-container matColumnDef="isEnabled">
                        <th mat-header-cell *matHeaderCellDef style="text-align: center;width: 100px;">
                            <div style="margin-bottom: 2px;">Run</div>
                            <!-- <mat-slide-toggle
                                (change)="onRunChanged($event)"
                                color="primary">
                            </mat-slide-toggle> -->
                        </th>
                    
                        <td mat-cell *matCellDef="let rule" style="text-align: center;width: 100px;" [ngStyle]="rule.ruleType === RuleType.findReplaceAdv ? {'border-left': '2px solid #ffa600'} : {}">
                            <ng-container *ngIf="rule.isGroup; else subheader">
                                <span>{{rule.isEnabled}}</span>
                             </ng-container>
                             <ng-template #subheader>
                                <ng-container *ngIf="rule.isSubHeader; else defaultCase">

                                </ng-container>
                            </ng-template>
                             <ng-template #defaultCase>
                                <mat-slide-toggle
                                color="primary"
                                [(ngModel)]="rule.run">
                            </mat-slide-toggle>
                             </ng-template>
                        </td>
                    </ng-container>

                    <!-- <ng-container matColumnDef="sampleHits">
                        <th style="border-left: 1px solid #ff9f0c;text-align: center;" mat-header-cell *matHeaderCellDef> Sample Row Hits
                        </th>
                        <td style="border-left: 1px solid #ff9f0c;text-align: center;" mat-cell *matCellDef="let rule"> {{rule.sampleHits |
                            number}} </td>
                    </ng-container> -->

                    <!-- <ng-container matColumnDef="hits">
                        <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Hits </th>
                        <td mat-cell *matCellDef="let rule"> 
                            <ng-container *ngIf="rule.isGroup; else groupheader">
                                <span>{{rule.hits}}</span>
                             </ng-container>
                             <ng-template #groupheader>
                                {{rule.hits | number}} 
                             </ng-template>

                            </td>
                    </ng-container> -->
                    <ng-container matColumnDef="rowsDeleted">
                        <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Deleted </th>
                        <td mat-cell *matCellDef="let rule"> 
                            <ng-container *ngIf="rule.isGroup; else subheader">
                                <span>{{rule.rowsDeleted}}</span>
                             </ng-container>
                             <ng-template #subheader>
                                <ng-container *ngIf="rule.isSubHeader; else defaultCase">

                                </ng-container>
                             </ng-template>
                             <ng-template #defaultCase>
                                {{rule.rowsDeleted | number}} 
                             </ng-template>

                            </td>
                    </ng-container>
                    <ng-container matColumnDef="rowsRemaining">
                        <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Remaining </th>
                        <td mat-cell *matCellDef="let rule"> 
                            <ng-container *ngIf="rule.isGroup; else subheader">
                                <span>{{rule.rowsRemaining}}</span>
                             </ng-container>
                             <ng-template #subheader>
                                <ng-container *ngIf="rule.isSubHeader; else defaultCase">

                                </ng-container>
                             </ng-template>
                             <ng-template #defaultCase>
                                {{rule.rowsRemaining | number}} 
                             </ng-template>

                            </td>
                    </ng-container>
                    <ng-container matColumnDef="valuesModified">
                        <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Modified </th>
                        <td mat-cell *matCellDef="let rule">
                            <ng-container *ngIf="rule.isGroup; else subheader">
                                <span>{{rule.valuesModified}}</span>
                             </ng-container>
                             <ng-template #subheader>
                                <ng-container *ngIf="rule.isSubHeader; else defaultCase">

                                </ng-container>
                             </ng-template>
                             <ng-template #defaultCase>
                                {{rule.valuesModified | number}}
                             </ng-template>

                            </td>
                    </ng-container>

                    <ng-container matColumnDef="groupHits">
                        <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Variants </th>
                        <td mat-cell *matCellDef="let rule">
                            <ng-container *ngIf="rule.isGroup; else subheaderVariants">
                                <span>{{rule.groupHits}}</span>
                             </ng-container>
                             <ng-template #subheaderVariants>
                                <ng-container *ngIf="rule.isSubHeader; else defaultCaseVariants">

                                </ng-container>
                             </ng-template>
                             <ng-template #defaultCaseVariants>
                                {{rule.groupHits | number}}
                             </ng-template>

                            </td>
                    </ng-container>

                    <!-- <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></tr> -->
                 <!-- <tr class="drag-component" mat-row *matRowDef="let row; columns: displayedColumns;"></tr>--> 
                   <tr
  class="drag-component"
  mat-row
  *matRowDef="let row; columns: displayedColumns;"
  (click)="onRowClicked($event, row)"
  [ngClass]="{'highlight-row': selectedRows.includes(row)}">
</tr>

                    <tr mat-row *matRowDef="let row; columns: displayedColumns; when: isGroup" class="group-header"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns; when: isSubHeader" class="group-subheader"></tr>

                    <div *cdkDragPlaceholder></div>
                </table>
            </div>
        </mat-expansion-panel>
        <!-- Results Dashboard -->
        <mat-expansion-panel class="mat-elevation-z0" [expanded]="isResultsPanelExpanded">
            <mat-expansion-panel-header (click)="setColumnCleanerResultsTabClicked()">Results Dashboard</mat-expansion-panel-header>
            <mat-tab-group animationDuration="300ms" [(selectedIndex)]="resultsDashboardTabIndex">
                <mat-tab label="Results">
                    <div style="position: relative">
                         <div style="position: absolute;left:200px;top: 4px; ">
                            <mat-form-field style="width: 120px" appearance="outline">
                                <mat-label>Farm Rows</mat-label>
                                <input readonly matInput placeholder="Rows" type="text" [value]="viewModel.rows | number">
                            </mat-form-field>
                            <mat-form-field style="width: 130px; margin-left: 3px;" appearance="outline">
                                <mat-label>Rows Deleted</mat-label>
                                <input type="text" readonly matInput placeholder="Rows Deleted" [value]="viewModel.rowsDeleted | number">
                            </mat-form-field>
                            <mat-form-field style="width: 135px; margin-left: 3px;" appearance="outline">
                                <mat-label>Rows Remaining</mat-label>
                                <input type="text" readonly matInput placeholder="Rows Remaining" [value]="viewModel.rowsRemaining | number">
                            </mat-form-field>
                            <mat-form-field style="width: 135px; margin-left: 3px;" appearance="outline">
                                <mat-label>Values Modified</mat-label>
                                <input type="text" readonly matInput placeholder="Values Modified" [value]="viewModel.valuesModified | number">
                            </mat-form-field>
                            <mat-form-field *ngIf="viewModel.variantCount != null" style="width: 100px; margin-left: 3px;" appearance="outline">
                                <mat-label>Variants</mat-label>
                                <input type="text" readonly matInput [value]="viewModel.variantCount | number"
                                    matTooltip="Distinct find-keys matched by this transform's Find & Replace rules" matTooltipPosition="above">
                            </mat-form-field>
                            <mat-form-field *ngIf="lastDtrRunTime" style="width: 120px; margin-left: 3px;" appearance="outline">
                                <mat-label>Uncompiled</mat-label>
                                <input type="text" readonly matInput [value]="lastDtrRunTime"
                                    matTooltip="Run Time (uncompiled) — time taken by the generic engine to execute this transform" matTooltipPosition="above">
                            </mat-form-field>
                            <mat-form-field *ngIf="lastDtrRunTime && isCompilable" style="width: 120px; margin-left: 3px;" appearance="outline">
                                <mat-label>When compiled</mat-label>
                                <input type="text" readonly matInput [value]="lastCompiledRunTime"
                                    matTooltip="Preview only — how fast the compiled fast-path engine would run this transform's CURRENT config (saved or not), not necessarily what production is using right now. Save to make this the actual compiled plan production runs. NA when the config isn't fully compilable or its own Run All Rows setting is off." matTooltipPosition="above">
                            </mat-form-field>
                        </div>
                        <app-preview-table [delegate]="this" #previewTable [hideRefresh]="true" [hideOptions]="true" previewType="temptransResult" previewTypeName="Result"
                            [viewModel]="previewDataViewModel"  ></app-preview-table>
                    </div>
                </mat-tab>
                <mat-tab label="Summary">
                    <button mat-raised-button color="primary" [matMenuTriggerFor]="menusummaryResult" #menuTriggerResult="matMenuTrigger"  style="margin-top: 3px;margin-left: 20px;margin-right: 50px;" (click)="showSelectFilterResult(menuTriggerResult)">Summary Fields</button>
                    <span>{{ totalSummaryRowsResult }}</span>
                    <mat-menu #menusummaryResult="matMenu" yPosition="below" style="margin-top: 2% !important;">
                        <app-select-filter-option [values]="selectValuesResult" [valuesColor]="selectValuesColorResult" [sources]="datafarmSourcesResult" [source]="sourceResult" [emptyColumns]="selectEmptyColumnsResult" [selectedColumns]="selectFilterValuesResult" columnName="Summary" (clearFilter)="onClearSelectResult($event)" (applyFilter)="onApplySelectResult($event)" (closeFilter)="onCloseSelectResult()"></app-select-filter-option>
                    </mat-menu>
                    <app-preview-table style="width: 100px;" [delegate]="this" #summaryDataFarmPreviewTableResult [hideRefresh]="true" previewType="Summary" 
                        [hideOptions]="true" [viewModel]="previewDataViewModel" [widthOptions]="true"  ></app-preview-table>
                </mat-tab>
            </mat-tab-group>
        </mat-expansion-panel>
        <!-- Data Farm Preview -->
        <mat-expansion-panel class="mat-elevation-z0" [expanded]="isPreviewPanelExpanded">
            <mat-expansion-panel-header (click)="setColumnCleanerPreviewTabClicked()">Data Farm Preview</mat-expansion-panel-header>
            <mat-tab-group animationDuration="300ms" [(selectedIndex)]="selectedIndex" (selectedTabChange)="onTabClick($event)">
                <mat-tab label="Input ({{inputcolumncount}})">
                    <div style="position: relative;">
                        <app-preview-table [delegate]="this" #inputDataFarmPreviewTable [hideRefresh]="true"
                            [hideOptions]="true" [viewModel]="previewDataViewModel" previewType="transInput" previewTypeName="Input"  ></app-preview-table>
                    </div>
                </mat-tab>
                <mat-tab label="Output ({{outputcolumncount}})">
                    <app-preview-table [delegate]="this" #outputDataFarmPreviewTable [hideRefresh]="true"
                        [hideOptions]="true" [viewModel]="previewDataViewModel" previewType="temptransOutput" previewTypeName="Output"  ></app-preview-table>
                </mat-tab>
                <mat-tab label="Summary (Input)">
                    <button mat-raised-button color="primary" [matMenuTriggerFor]="menusummaryinput" #menuTriggerInput="matMenuTrigger"  style="margin-top: 3px;margin-left: 20px;margin-right: 50px;" (click)="showSelectFilter(menuTriggerInput,'Input')">Summary Fields</button>
                    <span>{{ totalSummaryRowsInput }}</span>
                    <mat-menu #menusummaryinput="matMenu" yPosition="below" style="margin-top: 2% !important;">
                        <app-select-filter-option [values]="selectValuesInput" source="Input" [emptyColumns]="selectEmptyColumnsInput" [selectedColumns]="selectFilterValuesInput" columnName="Summary" (clearFilter)="onClearSelect($event)" (applyFilter)="onApplySelect($event)" (closeFilter)="onCloseSelect()" (changeSource)="onChangeSource($event)"></app-select-filter-option>
                    </mat-menu>
                    <app-preview-table style="width: 100px;" [delegate]="this" #summaryDataFarmPreviewTableInput [hideRefresh]="true" previewType="Summary" 
                        [hideOptions]="true" [viewModel]="previewDataViewModel" [widthOptions]="true"  ></app-preview-table>
                </mat-tab>
                <mat-tab label="Summary (Output)">
                    <button mat-raised-button color="primary" [matMenuTriggerFor]="menusummaryoutput" #menuTriggerOutput="matMenuTrigger"  style="margin-top: 3px;margin-left: 20px;margin-right: 50px;" (click)="showSelectFilter(menuTriggerOutput,'Output')">Summary Fields</button>
                    <span>{{ totalSummaryRowsOutput }}</span>
                    <mat-menu #menusummaryoutput="matMenu" yPosition="below" style="margin-top: 2% !important;">
                        <app-select-filter-option [values]="selectValuesOutput" source="Output" [emptyColumns]="selectEmptyColumnsOutput" [selectedColumns]="selectFilterValuesOutput" columnName="Summary" (clearFilter)="onClearSelect($event)" (applyFilter)="onApplySelect($event)" (closeFilter)="onCloseSelect()" (changeSource)="onChangeSource($event)"></app-select-filter-option>
                    </mat-menu>
                    <app-preview-table style="width: 100px;" [delegate]="this" #summaryDataFarmPreviewTableOutput [hideRefresh]="true" previewType="Summary" 
                        [hideOptions]="true" [viewModel]="previewDataViewModel" [widthOptions]="true"  ></app-preview-table>
                </mat-tab>
            </mat-tab-group>
        </mat-expansion-panel>
        <!-- Data Farm Export -->
        <mat-expansion-panel [disabled]="isDisabled" [expanded]="!isDisabled" class="mat-elevation-z0">
            <mat-expansion-panel-header (click)="DataFarmExport()">Data Farm Export</mat-expansion-panel-header>
            <app-export-output-data #exportOutputData [hideOptions]="true" 
            [viewModelExport]="viewModelExport"></app-export-output-data>
        </mat-expansion-panel>
    </mat-card-content>
</mat-card>

